import { BasePlugin, BaseStats } from '@fpkg/stats-core';
import { isMobile as isMobileFn } from '@fpkg/browser-env';

import { getCookie } from '../utils';

function checkMobile() {
  const { hostname } = window.location;
  const isH5Host = /acsp\.(sit\.?)sf-express\.com/gi.test(hostname);
  const isPCHost = /v\.(sit\.?)sf-express\.com/gi.test(hostname);
  if (isH5Host) {
    return true;
  }
  if (isPCHost) {
    return false;
  }
  return isMobileFn();
}

export default class AcspPlugin implements BasePlugin {
  name = 'acsp';

  stats?: BaseStats;

  isMobile = false;

  constructor({ isMobile = undefined }: { isMobile?: boolean } = {}) {
    this.isMobile = isMobile === undefined ? checkMobile() : isMobile;
  }

  setup(stats: BaseStats): void {
    this.stats = stats;

    if (this.isMobile) {
      this.initH5();
    } else {
      this.initPC();
    }
  }

  initPC() {
    this.stats?.registerCommonParams({
      gray_scale() {
        const grayScale = getCookie('grayScale');
        return grayScale === '1';
      },
      // 用户id，由于user_id是神策保留字段，只能用userid
      userid() {
        // 由于PC端旧系统用户信息都保存在localStorage.vuex中，所以需要兼容从vuex中获取
        // user包保存在localStorage.userId中（和h5保持一致）
        // sdk先兼容这两个场景，等企服pc调整完再移除
        const { userId = '' } = JSON.parse(localStorage.vuex || '{}');
        return localStorage.userId || userId;
      },
      buac_userid() {
        const { buac_userid = '' } = JSON.parse(localStorage.vuex || '{}');
        return localStorage.buacUserId || buac_userid;
      },
      open_id() {
        const { openId = '' } = JSON.parse(localStorage.vuex || '{}');
        return localStorage.openId || openId;
      },
      // 月结卡号
      monthcard() {
        const { custCode = '' } = JSON.parse(localStorage.vuex || '{}');
        return localStorage.monthCard || custCode;
      },
      // 用户类型：A=管理员;C=客服;D=普通用户
      usertype() {
        const { userType = '' } = JSON.parse(localStorage.vuex || '{}');
        return localStorage.userType || userType;
      },
      // 用户类型：1=个人;2=企业
      customer_type() {
        const { customerType = '' } = JSON.parse(localStorage.vuex || '{}');
        return localStorage.custType || customerType;
      },
      // 公司名称
      company_name() {
        const loginUserInfo = JSON.parse(localStorage.vuex || '{}');
        return localStorage.companyName || loginUserInfo.companyName || '';
      },
      // 客户分级信息
      // 客户分级只有user包接口会返回，不需要兼容旧vuex逻辑
      layer_name() {
        return localStorage.layerName;
      },
    });
  }

  initH5() {
    this.stats?.registerCommonParams({
      gray_scale() {
        const grayScale = getCookie('grayScale');
        return grayScale === '1';
      },
      // 用户id，由于user_id是神策保留字段，只能用userid
      userid() {
        return localStorage.userId || '';
      },
      buac_userid() {
        // user包新接口返回的b端用户id为小驼峰格式，buac_userid是旧接口返回的格式
        return localStorage.buacUserId || localStorage.buac_userid || '';
      },
      open_id() {
        return localStorage.openId || '';
      },
      // 月结卡号
      monthcard() {
        return localStorage.monthCard || '';
      },
      // 用户类型：A=管理员;C=客服;D=普通用户
      usertype() {
        return localStorage.userType || '';
      },
      // 用户类型：1=个人;2=企业
      customer_type() {
        return localStorage.custType || '';
      },
      // 公司名称
      company_name() {
        return localStorage.companyName || '';
      },
      // 客户分级信息
      layer_name() {
        return localStorage.layerName || '';
      },
    });
  }
}
